import { RiLoader5Fill } from "react-icons/ri";
import './Loader.scss';

type LoaderProps = {
    className?: string,
    size?: string,
    noMargin?: boolean,
};

function Loader(props: LoaderProps) {

    const size = props.size ?? '5rem';

    return (
        <div className={`loader-container ${props.className ?? ''} ${props.noMargin ? 'nomargin' : ''}`}>
            <div className="loader" style={{width: size, height: size}}>
                <RiLoader5Fill size={size}/>
            </div>
        </div>
    );
}

export default Loader;
